import { useContext } from "react";

import ProposalInputContext from "../../../context/ProposalInputContext";

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";

import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';

import ExpandableSectionHeader from "./ExpandableSectionHeader";

const ProposalInfoForm = () => {
  const {
    values, setValues, formErrors, collapseValues, setCollapseValue, sectionStyle
  } = useContext(ProposalInputContext);

  return (
    <Grid container spacing={2} sx={sectionStyle}>
      <ExpandableSectionHeader
        sectionTitle='1. Proposal Information'
        showSection='showProposalInfo'
        icon={<TextSnippetOutlinedIcon sx={{ color: "text.secondary" }} />}
        collapseValues={collapseValues}
        setCollapseValue={setCollapseValue}
      />

      {collapseValues?.showProposalInfo &&
        <>
          <Grid size={{ xs: 12 }}>
            <TextField
              variant="outlined"
              label="Proposal title *"
              name='opportunityName'
              value={values?.opportunityName}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  opportunityName: e.target.value
                }))
              }
              helperText={formErrors['opportunityName']}
              error={'opportunityName' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Proposal reference *"
              name='opportunityCrmRefNo'
              value={values?.opportunityCrmRefNo}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  opportunityCrmRefNo: e.target.value
                }))
              }
              helperText={formErrors['opportunityCrmRefNo']}
              error={'opportunityCrmRefNo' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <FormControl fullWidth>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label='Date'
                  name='date'
                  value={values?.date}
                  format="DD/MM/YYYY"
                  disabled
                  onChange={e =>
                    setValues(prev => ({
                      ...prev,
                      date: e
                    }))
                  }
                  renderInput={(params) =>
                    <TextField
                      {...params}
                      error={Boolean(formErrors['date'])}
                      helperText={formErrors['date']}
                    />
                  }
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>
        </>
      }
    </Grid>
  );
};

export default ProposalInfoForm;